var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "top-menu" } }, [
    _c(
      "div",
      { attrs: { id: "navbar-logo-container" } },
      [_c("SVGNavbarLogo")],
      1
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "navbar-user-container" } }, [
      _c("div", { attrs: { id: "user-text-container" } }, [
        _vm._v("\n            " + _vm._s(_vm.userName) + "\n        ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { id: "user-svg-container" },
          on: {
            click: function($event) {
              return _vm.showProfileModal()
            }
          }
        },
        [_c("SVGNavbarUser")],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }